/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Utilities from '../../util/Utilities';

/* Inserts an overlay Get image class name from content(eg. image50) and apply the percentage
 * to the overlay so that the overlay stays on the image and not
 * on the container which maybe wider.
 * callToAction should be a localized string.
 */

class Overlay extends Component {
  componentDidMount() {
    this.pearsonComponentNode = Utilities.closestByClassName(this.node, 'pearson-component');
    this.pearsonComponentNode.addEventListener('mouseover', this.handleMouseOver);
    this.pearsonComponentNode.addEventListener('mouseout', this.handleMouseOut);
  }

  componentWillUnmount() {
    this.pearsonComponentNode.removeEventListener('mouseover', this.handleMouseOver);
    this.pearsonComponentNode.removeEventListener('mouseout', this.handleMouseOut);
  }

  handleMouseOver = () => {
    this.pearsonComponentNode.classList.add('showOverlay');
  };

  handleMouseOut = () => {
    this.pearsonComponentNode.classList.remove('showOverlay');
  };

  render() {
    const { cbk, callToAction, ariaHidden = 'false' } = this.props;
    return (
      <div
        role="presentation"
        ref={(node) => { this.node = node; }}
        className="overlay"
        onClick={cbk}
        aria-hidden={ariaHidden}
      >
        <span role="button" tabIndex="0" onKeyPress={cbk}>{callToAction}</span>
      </div>
    );
  }
}

Overlay.propTypes = {
  callToAction: PropTypes.string.isRequired,
  cbk: PropTypes.func,
  ariaHidden: PropTypes.string
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/js/components/Overlay/Overlay.jsx